import React from "react";

const Contact = ({ handleScheduleClick }) => {
  return (
    <div className="with-navbar-offset">
      <div className="top-bar-wrapper enhanced-top-bar">
        <div className="container">
          <div className="row">
            <div className="col-12 top-bar-info-main enhanced-top-bar-info">
              <span className="lincensed-para enhanced-top-bar-text">
                ⭐ Not a licensed contractor
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Contact Page Content */}
      <div className="contact-page-container">
        <div className="contact-page-header">
          <h1 className="contact-page-title">
            Contact Us: Fast Help, Real People
          </h1>
          <h2 className="contact-page-subtitle">
            Need Handyman Help? Let's Get You Scheduled.
          </h2>
          <p className="contact-page-intro">
            We're fast, friendly, and ready to help. Whether you need a quick
            repair, an install, or a full list of things to tackle — we've got
            your back.
          </p>
          <div className="contact-page-highlight">
            <span role="img" aria-label="lightbulb">
              💡
            </span>{" "}
            Calls and chat are the fastest way to get scheduled — especially for
            same-day or next-day jobs.
          </div>
        </div>

        <div className="contact-methods-container">
          {/* Phone Contact Method */}
          <div className="contact-method-card">
            <h3 className="contact-method-title">
              <span role="img" aria-label="phone">
                📞
              </span>{" "}
              Call Us
            </h3>
            <p className="contact-method-action">
              <a href="tel:6029385415" className="contact-phone-link">
                Tap to call: (602) 938-5415
              </a>
            </p>
            <div className="contact-hours">
              <p>Hours: Mon–Fri, 8am–7pm, Sat-Sun, 9am-5pm</p>
              <p className="contact-hours-special">
                Summer Hours: We may start as early as 6am or go as late as 9pm
                when temps are over 90°
              </p>
            </div>
            <div className="contact-benefits">
              <p>
                <span role="img" aria-label="check">
                  ✔️
                </span>{" "}
                Fastest response
              </p>
              <p>
                <span role="img" aria-label="check">
                  ✔️
                </span>{" "}
                Great for questions about complex jobs or availability
              </p>
            </div>
          </div>

          {/* Chat Contact Method */}
          <div className="contact-method-card">
            <h3 className="contact-method-title">
              <span role="img" aria-label="robot">
                🤖
              </span>{" "}
              Chat with Alex (24/7)
            </h3>
            <p className="contact-method-description">
              Our smart assistant can quote jobs, answer questions, and even
              book appointments while you sleep.
            </p>
            <button
              className="contact-chat-button"
              onClick={handleScheduleClick}
            >
              <span role="img" aria-label="pointer">
                👉
              </span>{" "}
              Launch Alex Now
            </button>
            <div className="contact-benefits">
              <p>
                <span role="img" aria-label="check">
                  ✔️
                </span>{" "}
                Book instantly
              </p>
              <p>
                <span role="img" aria-label="check">
                  ✔️
                </span>{" "}
                Ask about pricing, timing, job types
              </p>
            </div>
          </div>

          {/* Email Contact Method */}
          <div className="contact-method-card">
            <h3 className="contact-method-title">
              <span role="img" aria-label="email">
                📩
              </span>{" "}
              Email (Slower Response)
            </h3>
            <p className="contact-method-description">
              For general inquiries or follow-ups:
            </p>
            <a
              href="mailto:info@breakthroughhandyman.com"
              className="contact-email-link"
            >
              <span role="img" aria-label="email">
                📧
              </span>{" "}
              info@breakthroughhandyman.com
            </a>
            <p className="contact-response-time">
              <span role="img" aria-label="clock">
                🕐
              </span>{" "}
              Please allow 24–48 hours for email replies.
            </p>
          </div>
        </div>

        {/* Service Area */}
        <div className="contact-service-area">
          <h3 className="contact-section-title">
            <span role="img" aria-label="location">
              📍
            </span>{" "}
            Where We Work
          </h3>
          <p className="contact-service-description">
            We proudly serve customers across Phoenix, AZ and surrounding cities
          </p>
          <p className="contact-service-note">
            If you're unsure if we cover your area — just ask Alex or give us a
            call.
          </p>
        </div>

        {/* Urgent CTA */}
        <div className="contact-urgent-cta">
          <h3 className="contact-urgent-title">
            <span role="img" aria-label="alert">
              🚨
            </span>{" "}
            Same-Day and Next-Day Appointments Available
          </h3>
          <p className="contact-urgent-description">
            Spots fill fast — reach out now to get scheduled.
          </p>
        </div>

        {/* CTA Buttons */}
        <div className="contact-cta-container">
          <a
            href="tel:6029385415"
            className="contact-cta-button contact-call-button"
          >
            <span role="img" aria-label="phone">
              📞
            </span>{" "}
            Call Now
          </a>
          <button
            className="contact-cta-button contact-chat-button"
            onClick={handleScheduleClick}
          >
            <span role="img" aria-label="chat">
              💬
            </span>{" "}
            Chat with Alex
          </button>
          <button
            className="contact-cta-button contact-schedule-button"
            onClick={handleScheduleClick}
          >
            <span role="img" aria-label="calendar">
              📅
            </span>{" "}
            Schedule Online
          </button>
        </div>
      </div>
    </div>
  );
};

export default Contact;
